import {
    useEffect,
    type FC,
    useRef
} from "react";
import type ITreeViewActionProps from "./type";
import stylesheet from "./stylesheet";
import {
    NCoreUIKitLocalize
} from "../../../../core/hooks";
import {
    usePointerType
} from "../../../../helpers/pointer";
import {
    useTreeViewSelector,
    useTreeViewContext
} from "../../context";
import {
    getIsTreeViewMenuFocusLost,
    focusTreeViewElement
} from "../../util";
import DropdownMenu from "../../../dropdownMenu";
import TreeViewMenuButton from "../menuButton";

const TreeViewAction: FC<ITreeViewActionProps> = ({
    isRowActive,
    entry,
    menu
}) => {
    const {
        handleMenuOpenChange,
        customLocalize,
        customTheme,
        itemRefs
    } = useTreeViewContext();

    const isOpen = useTreeViewSelector((snapshot) => snapshot.menuKey === entry.key);

    const {
        localize
    } = NCoreUIKitLocalize.useContext(customLocalize);

    const pointerType = usePointerType();

    const wasOpenRef = useRef(false);

    const onOpenChange = (isOpenValue: boolean) => {
        handleMenuOpenChange(entry.key, isOpenValue);
    };

    useEffect(() => {
        if(isOpen) {
            wasOpenRef.current = true;

            return;
        }

        if(!wasOpenRef.current) {
            return;
        }

        wasOpenRef.current = false;

        if(getIsTreeViewMenuFocusLost()) {
            focusTreeViewElement(itemRefs.current.get(entry.key));
        }
    }, [
        isOpen
    ]);

    return <DropdownMenu
        customLocalize={customLocalize}
        onOpenChange={onOpenChange}
        customTheme={customTheme}
        title={entry.node.title}
        isOpen={isOpen}
        align="end"
    >
        <DropdownMenu.Trigger
            style={stylesheet.trigger}
            customTheme={customTheme}
        >
            <TreeViewMenuButton
                isVisible={pointerType === "coarse" || isRowActive || isOpen}
                accessibilityLabel={localize("more-actions")}
            />
        </DropdownMenu.Trigger>
        <DropdownMenu.Content
            customTheme={customTheme}
        >
            {menu}
        </DropdownMenu.Content>
    </DropdownMenu>;
};
export default TreeViewAction;
